import { Box, Container, Grid, Theme, Typography } from '@material-ui/core';
import React, { FC, ReactNode } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';

interface JoinUsImageBgProps extends StyleProps {
  title: string;
}

type StyleProps = {
  image: string;
};

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      backgroundImage: ({ image }: Partial<StyleProps>) => `url(${image})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      marginTop: 0,
      marginBottom: theme.spacing(10),
      maxHeight: 385,
      backgroundPosition: 'center',
      padding: theme.spacing(10, 0),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(10, 0, 16),
        marginTop: theme.spacing(30.8),
        marginBottom: theme.spacing(44),
      },
    },
    title: {
      color: 'rgba(237, 103, 37, 1)',
      fontWeight: 900,
      fontSize: 120,
      maxWidth: 922,
      maxHeight: 288,
      textAlign: 'center',
      lineHeight: '144px',
      [theme.breakpoints.down('sm')]: {
        fontSize: 60,
        maxWidth: 500,
        lineHeight: '72px',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 30,
        maxWidth: 231,
        lineHeight: '36px',
      },
    },
  });
});

const SafetyText: FC<JoinUsImageBgProps> = (props) => {
  const { title, image } = props;
  const classes = useStyles({ image });
  return (
    <Box className={classes.root} display={'flex'} justifyContent={'center'}>
      <Typography className={classes.title} data-aos="fade-up" data-aos-delay="400">
        {title}
      </Typography>
    </Box>
  );
};

export default SafetyText;
